import { render, staticRenderFns } from "./DataSet.vue?vue&type=template&id=e1c50b3c&"
import script from "./DataSet.vue?vue&type=script&lang=js&"
export * from "./DataSet.vue?vue&type=script&lang=js&"
import style0 from "./DataSet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports